<template>
  <v-footer dark height="50px" class="pa-0" fixed app>
    <v-col class="text-center" cols="12">
      <v-btn v-for="link in links" :key="link.name" :href="link.url" target="_blank" color="white" flat round>
        {{ link.name }}
      </v-btn>
      <v-flex lighten-2 text-xs-center white--text xs12>
        © {{ currentYear }} — <strong>{{ companyName }}</strong>
        <v-btn icon target="_blank">
          <v-icon>business</v-icon>
        </v-btn>
      </v-flex>
    </v-col>
  </v-footer>
</template>
<script>
export default {
  name: 'Footer',

  props: {
    companyName: {
      default: '',
      type: String
    },
    site: {
      default: '',
      type: String
    },
    links: {
      default: () => [],
      type: Array
    }
  },

  data: () => ({
    currentYear: new Date().getFullYear()
  })
}
</script>
